import React, { useEffect } from 'react';
import './App.css';
import './styles/site.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import LocalizedHome from './pages/LocalizedHome';
import WeirdText from './pages/WeirdTextPage';
import DiscordFont from './pages/DiscordFontPage';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import PillarPage from './pages/PillarPage';
import CampaignToolPage from './pages/CampaignToolPage';
import { CAMPAIGN_TOOLS } from './data/campaign';
import { PILLARS } from './data/editorial';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import BioGenerator from './pages/BioGenerator';
import NotFound from './pages/NotFound';
import PageMetadata from './components/PageMetadata';
import ConsentProvider from './components/consent/ConsentProvider';
import ConsentBanner from './components/consent/ConsentBanner';
import { mountGoogleAnalytics } from './lib/googleAnalytics';
import SelineAnalytics from './components/SelineAnalytics';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App({ Router = BrowserRouter, routerProps = {} }) {
  useEffect(mountGoogleAnalytics, []);
  return (
    <div className="App min-h-screen flex flex-col">
      <Router {...routerProps}>
        <ConsentProvider>
        <SelineAnalytics />
        <PageMetadata />
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/fr/confidentialite" element={<Privacy lang="fr" />} />
            {PILLARS.map(pillar => <Route key={pillar.id} path={pillar.path} element={<PillarPage pillar={pillar} />} />)}
            {CAMPAIGN_TOOLS.map(page => <Route key={page.path} path={page.path} element={<CampaignToolPage page={page} />} />)}
            <Route path="/" element={<Home />} />
            <Route path="/weird-text-generator" element={<WeirdText />} />
            <Route path="/discord-font-generator" element={<DiscordFont />} />
            <Route path="/instagram-bio-generator" element={<BioGenerator />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:slug" element={<BlogPost />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/es/generador-de-texto-cursivo" element={<LocalizedHome lang="es" />} />
            <Route path="/fr/texte-bizarre" element={<WeirdText lang="fr" />} />
            <Route path="/fr/polices-discord" element={<DiscordFont lang="fr" />} />
            <Route path="/fr/a-propos" element={<About lang="fr" />} />
            <Route path="/fr/contact" element={<Contact lang="fr" />} />
            <Route path="/fr/blog" element={<Blogs lang="fr" />} />
            <Route path="/fr/blog/:slug" element={<BlogPost lang="fr" />} />
            <Route path="/fr/ecriture-cursive" element={<LocalizedHome lang="fr" />} />
            <Route path="/fr/generateur-bio-instagram" element={<BioGenerator lang="fr" />} />
            <Route path="/id/tulisan-keren" element={<LocalizedHome lang="id" />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <ConsentBanner />
        <Toaster position="bottom-center" richColors />
        </ConsentProvider>
      </Router>
    </div>
  );
}

export default App;
